import { render, staticRenderFns } from "./View_Notifications.vue?vue&type=template&id=56fe1ae2&scoped=true&"
import script from "./View_Notifications.vue?vue&type=script&lang=js&"
export * from "./View_Notifications.vue?vue&type=script&lang=js&"
import style0 from "./View_Notifications.vue?vue&type=style&index=0&id=56fe1ae2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fe1ae2",
  null
  
)

export default component.exports